import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContextProvider";

const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const { user, logout } = useContext(UserContext);
  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div className="header">
      <h2 className="font_16 font-600 clr_blue">Welcome {user.user || "User"}</h2>
      <ul className="nav align-items-center gap-3">
        <li>
          <Link to="/admin/dashboard" className="header_logo">
            <img src="/images/logo.png" className="img-fluid" alt="logo" />
          </Link>
        </li>
        <li>
          <div className="dropdown">
            <button 
              className="d-flex align-items-center gap-2 text-decoration-none dropdown-toggle"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              <img src="/images/user_profile.png" className="img-fluid rounded-circle" width="40" alt="User" />
            </button>
            
            {isDropdownOpen && (
              <div className="dropdown-menu dropdown-menu-end show" style={{ display: 'block' }}>
                <div className="user_info d-flex align-items-center gap-2 p-3">
                  <div className="img_box position-relative">
                    <img src="/images/user_profile.png" className="img-fluid rounded-circle" alt="user" width="45"/>
                    <span className="dot"></span>
                  </div>
                  <div className="info">
                    <h3 className="font_14 font-500 clr_blue mb-1">{user.user || "User"}</h3>
                    <p className="font_12 clr_grey">{user?.email || ""}</p>
                  </div>
                </div>
                <hr className="dropdown-divider my-2" />
                <Link 
                  className="dropdown-item d-flex align-items-center justify-content-between font_14 font-500 clr_blue py-2" 
                  to="/admin/profile"
                  onClick={() => setIsDropdownOpen(false)}
                >
                  Profile
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.3335 14.9998C3.3335 14.1158 3.68469 13.2679 4.30981 12.6428C4.93493 12.0177 5.78277 11.6665 6.66683 11.6665H13.3335C14.2176 11.6665 15.0654 12.0177 15.6905 12.6428C16.3156 13.2679 16.6668 14.1158 16.6668 14.9998C16.6668 15.4419 16.4912 15.8658 16.1787 16.1783C15.8661 16.4909 15.4422 16.6665 15.0002 16.6665H5.00016C4.55814 16.6665 4.13421 16.4909 3.82165 16.1783C3.50909 15.8658 3.3335 15.4419 3.3335 14.9998Z" stroke="#344054" strokeWidth="1.33333" strokeLinejoin="round"/>
                    <path d="M10 8.33325C11.3807 8.33325 12.5 7.21396 12.5 5.83325C12.5 4.45254 11.3807 3.33325 10 3.33325C8.61929 3.33325 7.5 4.45254 7.5 5.83325C7.5 7.21396 8.61929 8.33325 10 8.33325Z" stroke="#344054" strokeWidth="1.33333"/>
                  </svg>
                </Link>
                <Link 
                  className="dropdown-item d-flex align-items-center justify-content-between font_14 font-500 clr_blue py-2" 
                  to="/admin/change-password"
                  onClick={() => setIsDropdownOpen(false)}
                >
                  Change Password
                  <img src="/images/key.svg" className="img-fluid" alt="password" />
                </Link>
                <button 
                  className="dropdown-item d-flex align-items-center justify-content-between font_14 font-500 clr_blue py-2" 
                  onClick={handleLogout}
                  style={{ background: 'none', border: 'none', width: '100%', textAlign: 'left' }}
                >
                  Logout
                  <img src="/images/logout.svg" className="img-fluid" alt="logout" />
                </button>
              </div>
            )}
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Header;